// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__i7f8L","title":"Images45_title__21hpu","images":"Images45_images__eO77y"};